// Sugalarm — Cycle 456: the "Who's treating?" picker's two endpoints.
//
//   GET    /api/members/{id}/heroes/roster         → the tiles (no contact detail)
//   POST   /api/members/{id}/custody/attribution   → attribute the open window
//   DELETE /api/members/{id}/custody/attribution   → Undo
//
// The source (`kiosk_pick` / `phone_pick`) is derived by the server from the
// credential; the client never sends one. `window` is the open window's
// `custody_opened_at`, so a stale picker from an earlier window is refused
// (409) rather than writing onto the new one.

import { request } from "../lib/apiClient";
import type { ApiResult, HeroRosterItem, TreatingBy } from "../lib/types";

export function roster(memberId: string): Promise<ApiResult<HeroRosterItem[]>> {
  return request<HeroRosterItem[]>(
    `/api/members/${encodeURIComponent(memberId)}/heroes/roster`,
  );
}

export function attribute(
  memberId: string,
  window: string,
  heroId: string | null,
): Promise<ApiResult<TreatingBy | null>> {
  return request<TreatingBy | null>(
    `/api/members/${encodeURIComponent(memberId)}/custody/attribution`,
    { method: "POST", body: { window, hero_id: heroId } },
  );
}

export function undo(
  memberId: string,
  window: string,
): Promise<ApiResult<TreatingBy | null>> {
  const params = new URLSearchParams({ window });
  return request<TreatingBy | null>(
    `/api/members/${encodeURIComponent(memberId)}/custody/attribution?${params.toString()}`,
    { method: "DELETE" },
  );
}
